import { Box } from "@mui/material";
import React, { useCallback, useMemo } from "react";
import QUESTIONS, { SurveyQuestion } from "./surveyQuestions";
import { onboardingSurveyClosed } from "../../mixPanelEvents/mixPanelEvents";
import SurveyBreadcrumbs from "../../surveyStepper/SurveyBreadcrumbs";

type SurveyQuestionHeaderProps = {
  closeSurvey: () => void;
  currentQuestionId: number;
  goBack: () => void;
};

const steps = [
  { val: "primary_focus", label: "FOCUS" },
  { val: "primary_flaw", label: "FLAW" },
  { val: "scoring_goal", label: "SCORING" },
];

const SurveyQuestionHeader: React.FC<SurveyQuestionHeaderProps> = ({
  closeSurvey,
  currentQuestionId,
  goBack,
}) => {
  const currentQuestion = useMemo<SurveyQuestion>(
    () => QUESTIONS[currentQuestionId],
    [currentQuestionId]
  );

  const currentStepIndex = useMemo(() => {
    return steps.findIndex(
      (step) => step.val === currentQuestion.playerProfileField
    );
  }, [currentQuestion]);

  const onClose = useCallback(() => {
    closeSurvey();
    onboardingSurveyClosed("onboarding");
  }, [closeSurvey]);

  return (
    <SurveyBreadcrumbs
      currentStepIndex={currentStepIndex}
      onBack={goBack}
      onClose={onClose}
      showBack={currentQuestionId !== 0}
    />
  );
};

export default SurveyQuestionHeader;
